import { SideSheet, Textarea, TextField } from '@equinor/eds-core-react';
import { styled } from 'styled-components';

export const StyledSideSheet = styled(SideSheet)`
  width: 40%;
  position: fixed;
  top: 64px;
  right: 0;
  height: calc(100vh - 64px);
  background-color: white;
  z-index: 1000;
  overflow: auto;
`;

export const StyledTextField = styled(TextField)`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

export const StyledTextarea = styled(Textarea)`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;
